import script from "./FiltersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersTab.vue?vue&type=script&setup=true&lang=js"

import "./FiltersTab.vue?vue&type=style&index=0&id=30f1b2a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f1b2a8"]])

export default __exports__